import { z } from 'zod';
import { placeholderFortuneImage } from '@/appconstants';

export const Video = z.object({
  age: z.string().catch('Just now'),
  duration: z.string().catch(''),
  id: z.string().catch(''),
  showVideoDetails: z.boolean().optional(),
  summary: z.string().catch(''),
  thumbnail: z.url().catch(placeholderFortuneImage),
  title: z.string().catch(''),
  videoUrl: z.url().catch(''),
});

export const VodVideo = z.object({
  adsAllowed: z.boolean().catch(false),
  categories: z
    .array(
      z.object({
        label: z.string().catch(''),
        name: z.string().catch(''),
        type: z.string().catch(''),
      }),
    )
    .catch([]),
  createdAt: z.number().catch(0),
  customTranscript: z.string().catch(''),
  destination: z.object({
    onDemand: z.boolean().catch(false),
  }),
  duration: z.object({
    unit: z.string().catch('seconds'),
    value: z.number().catch(0),
  }),
  hideTranscript: z.boolean().catch(false),
  hlsFormat: z.object({
    extension: z.string().catch(''),
    key: z.string().catch(''),
    status: z.string().catch(''),
    type: z.string().catch(''),
    version: z.number().catch(0),
    videoId: z.string().catch(''),
  }),
  longDescription: z.string().catch(''),
  name: z.string().catch(''),
  originalImage: z.string().catch(placeholderFortuneImage),
  originalImageDescription: z.string().catch(''),
  playlists: z.array(z.string().catch('')).catch(['Conferences: All Videos']),
  premium: z.boolean().catch(false),
  resizedOriginalImages: z.array(z.string().catch('')).catch([placeholderFortuneImage]),
  resizedOriginalImagesPillarboxFree: z.array(z.string().catch('')).catch([placeholderFortuneImage]),
  resizedSocialImages: z.array(z.string().catch('')).catch([placeholderFortuneImage]),
  section: z.object({
    label: z.string().catch(''),
    name: z.string().catch(''),
    type: z.string().catch(''),
  }),
  slug: z.string().catch(''),
  srtFormat: z.object({
    status: z.string().catch(''),
    type: z.string().catch(''),
    version: z.number().catch(0),
    videoId: z.string().catch(''),
  }),
  tags: z
    .array(
      z.object({
        label: z.string().catch(''),
        name: z.string().catch(''),
        type: z.string().catch(''),
      }),
    )
    .catch([]),
  topics: z
    .array(
      z.object({
        label: z.string().catch(''),
        name: z.string().catch(''),
        type: z.string().catch(''),
      }),
    )
    .catch([]),
  updatedAt: z.string().catch(''),
  videoId: z.string().catch(''),
  videoPublishDate: z.number().catch(0),
});
export const VodVideoPlaylist = z.object({
  name: z.string().catch(''),
  premium: z.boolean().catch(false),
  state: z.string().catch(''),
  totalVideos: z.number().catch(0),
  type: z.string().catch(''),
  videosOrderedByUser: z.array(VodVideo).catch([]),
});

export type Video = z.infer<typeof Video>;
export type VodVideoPlaylist = z.infer<typeof VodVideoPlaylist>;
export type VodVideo = z.infer<typeof VodVideo>;
